import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
    formControl: {
        margin: theme.spacing(1),
        width: "100%"
    },
    input: {
        fontFamily: "Helvetica"
    }
}));